import React from "react";
import { failureMessageConstant } from "../../constants";
import PropTypes from "prop-types";

const CouponCodes = ({ codes, handleClose }) => {
  return (
    <div className="fixed left-0 top-0 z-50 flex size-full items-start justify-center border-grey-DDDFDE bg-black-00000030">
      <div className="relative mt-9.5 h-73.5 w-457px rounded-lg bg-white p-6">
        <div className="flex flex-col">
          <div className="font-MontserratSemiBold text-ft22-26.82-0.4 text-black-131426">
            Coupon Codes
          </div>
          <div className="mt-25px h-32 w-409px items-center justify-center overflow-y-auto rounded border border-grey-D9D9D9 bg-grey-F8F8F8 ">
            <p className="px-3 pt-10.72px font-MontserratMedium text-ft15-26.25 text-grey-767676">
              {Array.isArray(codes)
                ? codes.join(", ")
                : failureMessageConstant.NO_CODE_AVAILABLE}
            </p>
          </div>
          <div className="mt-6 flex justify-center">
            <button
              onClick={handleClose}
              className="h-12 w-183px rounded border border-grey-D9D9D9 px-17.5 py-11px"
            >
              <span className="font-MontserratMedium text-ft15-26.25">
                Close
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
CouponCodes.propTypes = {
  codes: PropTypes,
  handleClose: PropTypes
};
export default CouponCodes;
